import ImportRecords from './import-records.js';


export default class ImportTrainers extends ImportRecords {


	constructor(params = {})
	{
		const defaults = { 
			container:   '.import-trainers',
			contents:    '.trainer-list',
			cached_key:  'queued-trainers',
			spinner_msg: 'Importing trainers...please wait',
			ajax_path:   '/admin/import/users/trainer/partials'
		}

		var p = { ...defaults, ...params };

		super(p);
	}


}